import React, { useState, useRef, useEffect } from "react";
import { Form } from "react-bootstrap";
import "./SuggestionInput.css";

const SuggestionInput = ({
  type,
  formType,
  placeholder,
  className,
  readOnly,
  value,
  onChange,
  name,
  required,
  suggestions,
  inputRef,
  setError,
  cityLoaded,
  shouldValidate = true,
  ...props
}) => {
  const wrapperRef = useRef(null);

  const [showSuggestions, setShowSuggestions] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  // Filter suggestions based on input value
  useEffect(() => {
    if (!suggestions || !Array.isArray(suggestions)) return;

    const filtered = suggestions.filter((suggestion) =>
      suggestion.label.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredSuggestions(filtered);
  }, [value, suggestions]);

  // Handle click outside to close suggestions
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const validateCity = (inputValue) => {
    const cityRegex = /^[a-zA-Z0-9\s\-()&-',.]{1,50}$/;
    const isValidFormat = cityRegex.test(inputValue.trim());
    const matchesSuggestion =
      Array.isArray(suggestions) &&
      suggestions.some(
        (s) => s.label.toLowerCase() === inputValue.toLowerCase()
      );

    if (name === "city" && shouldValidate && cityLoaded) {
      if (!inputValue.trim()) {
        setError((prev) => ({
          isValid: false,
          errors: {
            ...prev.errors,
            [name]: "Invalid City",
          },
        }));
      } else if (!isValidFormat) {
        setError((prev) => ({
          isValid: false,
          errors: {
            ...prev.errors,
            [name]: "Invalid City",
          },
        }));
      }
      // else if (suggestions?.length > 0 && !matchesSuggestion) {
      //   setError((prev) => ({
      //     ...prev,
      //     [name]: "Please select a valid city from the list",
      //   }));
      // }
      else {
        setError((prev) => {
          const updatedErrors = { ...prev.errors };
          delete updatedErrors[name];
          return {
            isValid: Object.keys(updatedErrors).length === 0,
            errors: updatedErrors,
          };
        });
      }
    }
  };

  const handleInputChange = (e) => {
    onChange(e);
    validateCity(e.target.value);
  };

  const handleBlur = (e) => {
    validateCity(e.target.value);
  };

  const handleSuggestionClick = (suggestion) => {
    const syntheticEvent = {
      target: {
        name,
        value: suggestion.label,
      },
    };
    onChange(syntheticEvent);
    setShowSuggestions(false);
  };

  return (
    <div className="suggestion-input-wrapper" ref={wrapperRef}>
      <Form.Control
        ref={inputRef}
        type={type}
        placeholder={placeholder}
        className={className}
        readOnly={readOnly}
        value={value}
        onChange={handleInputChange}
        onBlur={handleBlur}
        name={name}
        required={required}
        onFocus={() => setShowSuggestions(true)}
        {...props}
      />

      {showSuggestions && filteredSuggestions.length > 0 && (
        <div className="suggestion-dropdown">
          {filteredSuggestions.map((suggestion, index) => (
            <div
              key={index}
              className="suggestion-item"
              onClick={() => handleSuggestionClick(suggestion)}
            >
              {suggestion.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SuggestionInput;
